import styled from 'styled-components/macro'

// Prototype item-card / order-ahead dropdown shell: --surface-card popover,
// --border-subtle edge, radius 14px, soft purple shadow, padding 6px.
export const KebabMenuPopover = styled.div`
  min-width: 210px;
  width: max-content;
  max-width: 320px;
  background: var(--surface-card);
  border: 1px solid var(--border-subtle);
  border-radius: 14px;
  box-shadow: 0 12px 32px -8px rgba(20, 2, 76, 0.28);
  display: flex;
  flex-direction: column;
  padding: 6px;
`

// Prototype dropdown row: 15px --text-primary label, padding 12px, radius 9px,
// hover --surface-page. The neutral fill+ink pair (--text-primary on
// --surface-page) themes; the $danger branch rides the ORDER-AHEAD CRIMSON as
// tokens now: ink --lane-failed-accent (pearl-exact #e0443f) + hover wash
// --lane-failed-soft (rgba(224,68,63,.14) over the card ground; was #fceeec,
// small DISCLOSED delta) — the same lane family, so the pair re-binds together
// in dark themes. Adopting --status-danger/--status-danger-soft (#d04c00 /
// #fbe9de pearl) remains the coordinated order-ahead danger drift-correction
// FLAGGED for Wave 3, per the manifest.
export const KebabMenuItem = styled.button<{ $danger?: boolean }>`
  display: flex;
  align-items: center;
  gap: 11px;
  width: 100%;
  text-align: left;
  border: none;
  background: transparent;
  cursor: pointer;
  font-family: inherit;
  font-size: 15px;
  color: ${({ $danger }) =>
    $danger ? 'var(--lane-failed-accent)' : 'var(--text-primary)'};
  padding: 12px;
  border-radius: 9px;

  &:hover:not(:disabled) {
    background: ${({ $danger }) =>
      $danger ? 'var(--lane-failed-soft)' : 'var(--surface-page)'};
  }

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`

/** Leading icon gutter — inherits danger ink from the row when `$danger`. */
export const KebabMenuIcon = styled.span<{ $danger?: boolean }>`
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${({ $danger }) =>
    $danger ? 'var(--lane-failed-accent)' : 'var(--text-muted)'};
`
